import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "./breadcrumbs.module.scss";
import {Tooltip} from "../tooltip/tooltip";
import {TOOLTIP_PLACEMENT, TOOLTIP_TRIGGER} from "../tooltip/tooltip-consts";
import {BreadcrumbsList} from "./breadcrumbs.list";
import {BREADCRUMBS} from "./breadcrumbs.consts";

class BreadcrumbsDotsProps extends BaseProps {}

export const BreadcrumbsDots = observer(({controller}: BreadcrumbsDotsProps) => {
  const tooltipProps = {
    className: classNames(styles.item),
    content: <BreadcrumbsList controller={controller} isCollapsed={true}/>,
    trigger: TOOLTIP_TRIGGER.click,
    placement: TOOLTIP_PLACEMENT.bottomStart,
    distance: BREADCRUMBS.TOOLTIP_DISTANCE,
    ignoreDeviceWidth: true,
    interactive: true,
    hideArrow: true,
  }

  return (
    <Tooltip {...tooltipProps}>
      <div className={classNames(styles.dot)}/>
      <div className={classNames(styles.dot)}/>
      <div className={classNames(styles.dot)}/>
    </Tooltip>
   )
});
